"use client";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";

interface Spark {
  id: number;
  startX: number;
  endX: number;
  startY: number;
  endY: number;
  size: number;
  duration: number;
  delay: number;
  color: string;
}

export default function AggressiveSparks() {
  const [sparks, setSparks] = useState<Spark[]>([]);

  useEffect(() => {
    const colors = ["#ff4500", "#ff8c00", "#ffd700", "#ff0000"];
    
    const particleCount = 50;
    const newSparks = Array.from({ length: particleCount }).map((_, i) => ({
      id: i,
      startX: 10 + Math.random() * 80, 
      endX: -20 + Math.random() * 140, 
      startY: 20 + Math.random() * 30, // start near the top where the image is
      endY: -20 - Math.random() * 40, // shoot upwards and outwards
      size: Math.random() * 4 + 2,
      duration: Math.random() * 3 + 2, // slower duration 2s - 5s
      delay: Math.random() * 4, // staggered starts
      color: colors[Math.floor(Math.random() * colors.length)]
    }));
    setSparks(newSparks);
  }, []);

  return (
    <div 
      className="absolute inset-0 overflow-visible pointer-events-none z-0" 
    >
      {sparks.map((p) => (
        <motion.div
          key={p.id}
          className="absolute rounded-full"
          style={{
            width: p.size,
            height: p.size * 2.5,
            backgroundColor: p.color,
            boxShadow: `0 0 12px 3px ${p.color}`,
          }}
          animate={{
            left: [`${p.startX}%`, `${p.endX}%`],
            top: [`${p.startY}%`, `${p.endY}%`],
            opacity: [0, 1, 0],
            scale: [0, 1, 0.2]
          }}
          transition={{
            duration: p.duration,
            ease: "easeOut",
            repeat: Infinity,
            delay: p.delay,
          }}
        />
      ))}
    </div>
  );
}
